// extracted by mini-css-extract-plugin
export default {"bottomBorder":"bottomBorder--mp-VdiCr"};